const AUTHCALLBACK = async () => await import('@/views/comm/AUTH-CALLBACK.vue')

export const routerComm = [
  {
    path: '/comm/AUTH-CALLBACK',
    component: AUTHCALLBACK,
    name: 'AUTH-CALLBACK',
    meta: {
      header: false,
      title: 'pass 인증 콜백 처리 화면',
      code: 'AUTH-CALLBACK',
      depth2: '기타',
      requireAuth: false
    },
    props: true
  }
]
